import SEO from "../components/common/SEO";
import HeroSection from "../components/Home/HeroSection";
import AboutSection from "../components/Home/AboutSection";
import VXDFSection from "../components/Home/VXDFSection";
import ProjectsHighlight from "../components/Home/ProjectsHighlight";
import ImpactSection from "../components/Home/ImpactSection";
import CTASection from "../components/Home/CTASection";

const Home = () => {
  return (
    <>
      <SEO
        title="Mihir Shah - OWASP VXDF Project Leader | Security Engineer & Author"
        description="Project Leader for OWASP VXDF (Validated Exploitable Data Flow), transforming vulnerability data management. Security engineer specializing in cloud security, application security, and author of Cloud Native Software Security Handbook."
        keywords="Mihir Shah, OWASP VXDF, Validated Exploitable Data Flow, OWASP Project Leader, Security Engineer, Cloud Security, Application Security, DevSecOps, Security Author"
        url="https://mihirshah.tech"
      />
      <div className="min-h-screen bg-brand-dark">
        <HeroSection />
        <AboutSection />
        <VXDFSection />
        <ProjectsHighlight />
        <ImpactSection />
        <CTASection />
      </div>
    </>
  );
};

export default Home;
